// src/services/pagesPersonnaliseesServices.js

import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/pages`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
};

/// GET
// Récupérer toutes les pages personnalisées côté admin
export const getAllPagesPersonnalisees = async () => {
  try {
    const response = await axios.get(`${apiUrl}/getAllPages`, {
      headers: getAuthHeaders(),
    });

    if (response.status !== 200) {
      throw new Error("Failed to fetch pages personnalisées");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des pages personnalisées :", error);
    return [];
  }
};

// Récupérer les pages actives affichées dans le menu public
export const getMenuPagesPersonnalisees = async () => {
  try {
    const response = await axios.get(`${apiUrl}/getMenuPages`, {
      headers: getAuthHeaders(),
    });

    if (response.status !== 200) {
      throw new Error("Failed to fetch menu pages");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des pages du menu :", error);
    return [];
  }
};

// Récupérer une page par son id côté admin
export const getPagePersonnaliseeById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/getPageById/${id}`, {
      headers: getAuthHeaders(),
    });

    if (response.status !== 200) {
      throw new Error("Failed to fetch page personnalisée");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement de la page personnalisée :", error);
    return null;
  }
};

// Récupérer une page publique par son slug
export const getPagePersonnaliseeBySlug = async (slug) => {
  try {
    const response = await axios.get(`${apiUrl}/getPageBySlug/${slug}`, {
      headers: getAuthHeaders(),
    });

    if (response.status !== 200) {
      throw new Error("Failed to fetch page by slug");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement de la page par slug :", error);
    return null;
  }
};

// Récupérer les articles d'une page depuis les routes pages
export const getArticlesByPageFromPages = async (pageId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/getAllArticlesByPage/${pageId}`,
      {
        headers: getAuthHeaders(),
      }
    );

    if (response.status !== 200) {
      throw new Error("Failed to fetch articles de la page");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des articles de la page :", error);
    return [];
  }
};

/// POST
// Ajouter une page personnalisée
export const addPagePersonnalisee = async (newPage) => {
  try {
    const response = await axios.post(`${apiUrl}/addPage`, newPage, {
      headers: getAuthHeaders(),
    });

    if (response.status !== 201) {
      throw new Error("Failed to add page personnalisée");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout d'une page personnalisée :", error);
    return null;
  }
};

/// PUT
// Modifier une page personnalisée
export const updatePagePersonnalisee = async (page) => {
  try {
    const response = await axios.put(`${apiUrl}/updatePage/${page.id}`, page, {
      headers: getAuthHeaders(),
    });

    if (response.status !== 200) {
      throw new Error("Failed to update page personnalisée");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification d'une page personnalisée :", error);
    return null;
  }
};

/// PATCH
// Activer / désactiver une page
export const updatePagePersonnaliseeVisibility = async (id, actif) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/updatePageVisibility/${id}`,
      { actif },
      {
        headers: getAuthHeaders(),
      }
    );

    if (response.status !== 200) {
      throw new Error("Failed to update page visibility");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification de visibilité de la page :", error);
    return null;
  }
};

// Afficher / masquer une page dans le menu
export const updatePagePersonnaliseeMenuVisibility = async (
  id,
  afficher_menu
) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/updatePageMenuVisibility/${id}`,
      { afficher_menu },
      {
        headers: getAuthHeaders(),
      }
    );

    if (response.status !== 200) {
      throw new Error("Failed to update page menu visibility");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification de l'affichage menu :", error);
    return null;
  }
};

/// DELETE
// Supprimer une page personnalisée
export const deletePagePersonnalisee = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/deletePage/${id}`, {
      headers: getAuthHeaders(),
    });

    if (response.status !== 200) {
      throw new Error("Failed to delete page personnalisée");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression d'une page personnalisée :", error);
    return null;
  }
};